import render from '@zr/components/bootstrapper';
import ApplyFlowApp from '@jobseeker/public/apps/jobseeker-screens/components/ApplyFlowApp';

interface ApplyFlowProps {
  applyParameters: Record<string, unknown>
}

export const initializeApplyFlow = (props: ApplyFlowProps): void => {
  const rootElement = document.getElementById('react-apply-flow-root');
  if (rootElement && props.applyParameters) {
    render(ApplyFlowApp, rootElement, props); // eslint-disable-line
  }
};
